import { useState, useEffect, useRef, RefObject } from 'react';

export function useOnScreen<T extends Element>(
  options?: IntersectionObserverInit,
): [RefObject<T>, boolean] {
  const ref = useRef<T>(null);
  //const [observedOnce, setObservedOnce]= useState(false);
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(entry.isIntersecting);
    }, options);

    const current = ref.current;
    if (current) {
      observer.observe(current);
    }
    if (isIntersecting && current) {
      observer.unobserve(current);
    }

    return () => {
      if (current) {
        observer.unobserve(current);
      }
    };
  }, [ref, options, isIntersecting]);

  return [ref, isIntersecting];
}
